import logger from '../utils/logger';
import doc from '../utils/document';
import win from '../utils/window';

const availableModes = ['element', 'image', 'background'];
const availableUnits = ['px', 'vw', 'vh', '%'];
const availableAuto = [undefined, 'ttb', 'btt', 'ltr', 'rtl'];
const defaultOptions = {
    mode: availableModes[0], // element
    unit: availableUnits[0], // px
    relativeViewport: true,
    x: [0, 0],
    y: [0, 0],
    scale: [1, 1],
    opacity: [1, 1],
    auto: undefined,
};

let windowHeight = 0;

let elements,
    trackLength;

let ticking = false;

function getRelativeScrollPercent(windowScrollTop, elOffsetTop, elHeight) {
    // element has not entered the viewport
    if (windowScrollTop + windowHeight < elOffsetTop) {
        return 0
    }

    // element already left the viewport again
    if (elOffsetTop + elHeight < windowScrollTop) {
        return 100
    }

    // if the offset is smaller then the winHeight
    if (elOffsetTop < windowHeight) {
        return windowScrollTop / (elOffsetTop + elHeight) * 100;
    } else {
        return (windowScrollTop - (elOffsetTop - windowHeight)) / (windowHeight + elHeight) * 100;
    }
}

function parallaxIt(el, elOptions) {
    const scrollTop = win.getScrollTop();
    let scrolledInPercent = 0;
    if (elOptions.relativeViewport) {
        scrolledInPercent = getRelativeScrollPercent(scrollTop,el.getBoundingClientRect().top + window.pageYOffset, el.offsetHeight);
    } else {
        scrolledInPercent = (scrollTop / trackLength * 100);
    }

    if (availableAuto.indexOf(elOptions.auto) !== -1 && elOptions.auto !== undefined) {
        // if ttb
        if (elOptions.auto === availableAuto[1]) {
            elOptions.y = [0, 100];
            elOptions.x = [50, 50];
            elOptions.unit = '%';
        }
        // if btt
        if (elOptions.auto === availableAuto[2]) {
            elOptions.y = [100, 0];
            elOptions.x = [50, 50];
            elOptions.unit = '%';
        }
        // if ltr
        if (elOptions.auto === availableAuto[3]) {
            elOptions.y = [50, 50];
            elOptions.x = [0, 100];
            elOptions.unit = '%';
        }
        // if rtl
        if (elOptions.auto === availableAuto[4]) {
            elOptions.y = [50, 50];
            elOptions.x = [100, 0];
            elOptions.unit = '%';
        }
    }

    let x = calcPercentrelatedValueBy(elOptions.x, scrolledInPercent);
    let y = calcPercentrelatedValueBy(elOptions.y, scrolledInPercent);
    let scale = calcPercentrelatedValueBy(elOptions.scale, scrolledInPercent);
    let opacity = calcPercentrelatedValueBy(elOptions.opacity, scrolledInPercent);

    el.style.opacity = `${opacity}`;
    if (elOptions.mode === 'element') {
        el.style.transform = `translateY(${y}${elOptions.unit}) translateX(${x}${elOptions.unit}) scale(${scale})`;
    } else if (elOptions.mode === 'background') {
        el.style.backgroundPosition = `${x}${elOptions.unit} ${y}${elOptions.unit}`;
        el.style.backgroundSize = elOptions.scale[0] !== 1 || elOptions.scale[1] !== 1 ? `${scale * 100}%` : 'cover';
    } else if (elOptions.mode === 'image') {
        el.style.objectPosition = `${x}${elOptions.unit} ${y}${elOptions.unit}`;
        el.style.transform = `scale(${scale})`;
    }
}

function getElementData(dataset) {
    const options = { ...defaultOptions, ...Object.assign({}, dataset) };
    const optStringsToArray = ['x', 'y', 'scale', 'opacity'];

    // Transform html data-attribute strings into correct types
    Object.keys(options).map((key) => {
        if (optStringsToArray.indexOf(key) !== -1 && typeof options[key] !== 'object')
            options[key] = options[key].split(',').map(x => Number(x));

        if (key === 'relativeViewport')
            options[key] = options[key] !== 'false';

    });

    // Validations
    if (availableModes.indexOf(options.mode) === -1)
        logger.error(`"${options.mode}" is not a valid mode.`, availableModes);

    if (availableUnits.indexOf(options.unit) === -1) {
        logger.error(`"${options.unit}" is not a valid unit.`, availableUnits);
    }

    if (availableAuto.indexOf(options.auto) === -1) {
        logger.error(`"${options.auto}" is not a valid auto property.`, availableAuto);
    }

    return options;
}

function update() {
    calcTrackLength();
    windowHeight = win.getHeight();
    elements.forEach((element) => {
        parallaxIt(element, getElementData(element.dataset));
    });
    ticking = false;
}

function onScrollHandler() {
    // using requestAnimationFrame for animating all elements
    if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
    }
}

function calcPercentrelatedValueBy(attribute, scrolledInPercent) {
    return (scrolledInPercent / 100) * (attribute[1] - attribute[0]) + attribute[0];
}

function calcTrackLength() {
    trackLength = doc.getHeight() - win.getHeight();
}

function fetchDomElements() {
    return Array.from(document.querySelectorAll('.js-parallax'));
}

export function destroyParallaxListeners() {
    // on scroll
    window.removeEventListener('scroll', onScrollHandler);
    // on resize
    window.removeEventListener("resize", calcTrackLength);
}

export default function init() {
    // fetch and set elements to parallax
    elements = fetchDomElements();

    // initial tick
    onScrollHandler();

    // listener registration
    // on scroll
    window.addEventListener('scroll', onScrollHandler);
    // on resize
    window.addEventListener("resize", calcTrackLength);
}
